import React, { Component } from 'react';
import './styles.css';
import Body from './Body';

class StepperLayout extends Component {
	render() {
		return <div className="stepper-layout">{this.props.children}</div>;
	}
}

Object.assign(StepperLayout, {
	Body
});

export default StepperLayout;
